import { SIDEBAR_STORAGE_KEY } from '@e2m-customer-portal/core';
import { IconButton } from '@mui/material';
import { CollapseIcon } from 'assets/icons';
import clsx from 'clsx';
import { Breakpoints } from 'domains/forecast/utils';
import { ReactNode, ReactElement, useState, useEffect } from 'react';
import { useToggle } from 'react-use';

interface CollapsibleChartProps {
  title?: string;
  children?: ReactNode;
}

export function CollapsibleChart({
  title,
  children,
}: Readonly<CollapsibleChartProps>): ReactElement<CollapsibleChartProps> {
  const SIDEBAR_EXPANDED_WIDTH = 320;
  const SIDEBAR_COLLAPSED_WIDTH = 68;
  const [expanded, toggleExpanded] = useToggle(true);

  const isSidebarExpanded = JSON.parse(localStorage.getItem(SIDEBAR_STORAGE_KEY) ?? 'true');
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    if (window.innerWidth < Breakpoints.MD) setWidth(window.innerWidth);
    else setWidth(window.innerWidth - (isSidebarExpanded ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH));
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [isSidebarExpanded]);

  return (
    <div className="pb-6 group">
      <div className="ml-16 mr-32 flex flex-col group-first-of-type:border-none pt-4 border-solid border-0 border-t border-divider">
        <div className="mt-2.5 flex items-center gap-4 font-bold text-sm leading-none">
          <IconButton onClick={toggleExpanded}>
            <CollapseIcon
              className={clsx('size-4 text-black flex justify-center items-center transition-transform', {
                '-scale-y-100': expanded,
              })}
            />
          </IconButton>
          {title}
        </div>
      </div>
      <div style={{ width }}>{expanded && children}</div>
    </div>
  );
}
